export default __webpack_public_path__ + "dc3fb9fdf3265f8bdbf0ad43e5b8b182.png";